export const FIRST_PAGE_VIEWED = 'fpViewed';
export const AJS_ANONYMOUS_ID = 'ajs_anonymous_id';
export const LANDING_EMAIL = 'landing_email';
export const USER_REQUESTED_ENROLLMENT_START =
  'user_requested_enrollment_start';
export const TRACKED_USER_ENTERED_ENROLLMENT = 'user_entered_enrollment';
export const OPTIMIZELY_NOT_INITIALIZED = 'OPTIMIZELY_NOT_INITIALIZED';
export const SAVED_ACCOUNT_DATA = 'saved_account_data';

export const INQUIRY_ID = 'inquiryId';
export const VERIFICATION_ID = 'verificationId';
export const CHIME_SESSION_TOKEN = 'Chime-Session';
export const CHIME_APPLICATION_TOKEN = 'Chime-Application-Token';
export const CHIME_DEVICE_ID = 'Chime-Device-ID';
export const CHIME_DEVICE_INTELLIGENCE = 'Chime-Device-Intelligence';

// Cookies from server that help determine session
export const CSRF_TOKEN = 'X-CSRF-Token';

// For flows that need temporary session (Splitting email and name to separate pages)
export const LOCAL_FORM_DATA_KEY = 'formData';

// Used for deciding if we need to do hard session reset without timer for native handoff flows
export const NEED_HARD_RESET = 'NEED_HARD_RESET';

export const CONVERSION_TRACKED = 'conversionTracked';
export const CJ_EVENT_COOKIE = 'CJEVENT';

// Pay Anyone Incentives
export const PAI_TOKEN = 'pai_token';
export const PF_PUBLIC_ID_COOKIE_NAME = 'pf_publicId';

// Pay Anyone/Friends Token
export const PF_TOKEN = 'pf_token';

//Facebook ClickID and Pixel Identifier
export const Facebook_Click = '_fbc';
export const Facebook_Pixel_Identifier = '_fbp';

export const ARKOSE_TOKEN = 'arkose_token';

export const AUTH_TOKEN = 'auth_token';
export const CLAIM_WITH_DEBIT = 'claim_with_debit';
export const KYC_ATTEMPTED = 'kyc_attempted';
export const PF_EMAIL = 'pf_email';
export const REFERRER_NAME = 'referrer_name';
export const REFERRAL_TOKEN = 'referral_token';
export const REFERRED_BY_ID = 'ch_rafid';
export const INCENTIVE_FIELDS = 'incentive_fields';
export const PAI_SENDER_NAME = 'pai_sender';
export const PROVE_CORRELATION_UUID = 'prove_correlation_uuid';
export const IS_BUCKETED_INTO_PREFILL_VARIANT_1 =
  'is_bucketed_into_prefill_variant_1';

export const IS_METAL_CARD_ENROLLMENT_ENABLED =
  'is_metal_card_enrollment_enabled';

export const CARD_PRODUCT_NAME = 'card_product_name';
export const REDIRECTED_FROM_WEB_APP = 'redirected_from_web_app';
export const METAL_CARD_SELECTED = 'mc_selected';
